module.exports = __webpack_public_path__ + "static/media/avatar.96a12403.jpg";